import Errors from "./Errors";

type ProblemDetails = {
    errors: Errors;
    status: number;
    title: string;
};

export default ProblemDetails;


export function problemDetailsHasErrors(problemDetails: ProblemDetails): boolean {
    const hasErrors = !!problemDetails.errors && Object.keys(problemDetails.errors).length > 0;

    return hasErrors;
}